module.exports = __webpack_public_path__ + "media/assets/images/icons/profile-generic/avatar-example-1-1a36ad6cf6a7b7e3c5cb4b10746478ea.png";